module.exports = __webpack_public_path__ + "img/AvatarStarter.607ed58b.svg";